// extracted by mini-css-extract-plugin
export default {"mCard":"RB-z","image":"SB-z","imageNoBackground":"TB-z","imageHasCategory":"UB-z","fullWidth":"VB-z"};